export default __webpack_public_path__ + "static/SustainableFutures-VolunteerGuide-6b0129e1b6dcbbaeb4ab17f3e8a77520.pdf";